const config = {};

export const loadConfig = async () => {
  const response = await fetch('/config.json');
  const json = await response.json();
  Object.assign(config, json);
};

export default config;